/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, PLATFORM_ID } from '@angular/core';
import { USER_ACCESS_TOKEN_KEY } from '@common';
import { ToastService } from '@front-share';
import { catchError, Observable, throwError } from 'rxjs';

export const interceptor = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const toastService = inject(ToastService);
  const platformId = inject(PLATFORM_ID);

  // 요청 클론 및 헤더 설정
  request = request.clone({
    withCredentials: true,
    headers: request.headers.set(
      'Cache-Control',
      'no-cache, no-store, must-revalidate',
    ),
  });

  // 요청 직전에 쿠키 정보를 콘솔에 출력
  if (isPlatformBrowser(platformId)) {
    const getCookie = (name: string): string | null => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts?.pop()?.split(';').shift() ?? '';
      return null;
    };

    const userAccessToken = getCookie(USER_ACCESS_TOKEN_KEY);
  }

  return next(request).pipe(
    catchError((e) => {
      if (isPlatformBrowser(platformId)) {
        if (e.error.error_message) {
          toastService.show({
            type: 'error',
            message: e.error?.error_message,
            positionClass: 'toast-top-right',
          });
        }
        return throwError(() => e.error);
      } else {
        return throwError(() => e.error);
      }
    }),
  );
};
